<template>
  <div
    class="modal-holder"
    :class="{ 'modal-holder-mini': !product.option.length }"
  >
    <button class="close-button editorial" @click="handleClose">
      x
    </button>
    <!-- Product Region  -->
    <section class="product-region">
      <h2 class="product-name editorial">{{ product.name | capitalize }}</h2>
      <p class="price" v-if="product.price">
        {{ product.price ? `$${product.price}` : '' }}
      </p>

      <!-- Image Here -->
      <div class="image-region">
        <div class="image">
          <div v-if="isHEIC" class="image-holder">
            <span v-if="imageUrl === null"> Loading... </span>
            <span v-else>
              <img
                :src="imageUrl"
                alt="image"
                @error="handleBrokenImage($event)"
              />
            </span>
          </div>
          <div v-else class="image-holder">
            <img
              :src="product.image"
              alt="image"
              @error="handleBrokenImage($event)"
            />
          </div>
        </div>
      </div>
      <div class="product-text-region" v-if="showSelectDropdown">
        <p>This product has one or more options.</p>
        <p>
          Please make the required selections and Save to select this product.
        </p>
      </div>

      <div class="product-checkbox" v-if="!showSelectDropdown">
        <div class="checkbox-container-holder">
          <label class="checkbox-container">
            <input
              type="checkbox"
              @change="handleSelection"
              :checked="isSelected"
            />
            <span class="checkmark"></span>
            <p>Select product</p>
          </label>
        </div>
      </div>

      <!-- Product Details -->
    </section>

    <div
      class="product-details"
      :class="{
        'modal-overflow': product.option.length > 4,
        'product-details-mini': !product.option.length
      }"
    >
      <h2 class="product-name editorial">{{ product.name | capitalize }}</h2>
      <p class="price">
        {{ product.price ? `$${product.price}` : '' }}
      </p>

      <div class="product-description">
        <div class="product-description-header">
          <p>Product Details</p>
          <button @click="showProductDescription = !showProductDescription">
            <img
              src="../../../assets/plus.svg"
              alt="close"
              v-show="!showProductDescription"
            />
            <img
              src="../../../assets/subtract.svg"
              alt="close"
              v-show="showProductDescription"
            />
          </button>
        </div>

        <div class="product-description-content">
          <p :class="{ active: showProductDescription }">
            {{ product.description || 'N/A' }}
          </p>
        </div>
      </div>

      <section v-if="showSelectDropdown">
        <div
          class="dropdown-holder"
          v-for="(option, i) in product.option"
          :key="i"
        >
          <!-- <div class="flex items-center gap-1 dropdown-holder-title">
            <p>{{ Object.keys(option)[0] | capitalize }}</p>
            <div v-if="showValidationError" class="validation-error">
              <small>Required</small>
            </div>
          </div> -->
          <Select
            ref="selectedItem"
            :product="product"
            :selectedItems="selectedItems"
            :option="product.option[i]"
            validationErrorPosition="top"
            @showValidationError="
              showError => (showValidationError = showError)
            "
          />
        </div>

        <section v-if="product.option.length" class="button-region">
          <button class="finalize-button" @click="handleSelection">
            save
          </button>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import { handleBrokenImage } from '@/helpers'
import HEICConversion from '../../../mixins/HEICConversion'
import Select from './SingleSelect.vue'
export default {
  name: 'Singleproduct',
  components: { Select },
  mixins: [HEICConversion],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    handleBrokenImage: handleBrokenImage,
    selectedItem: '',
    showProductDescription: false,
    showSelectDropdown: false,
    showValidationError: false
  }),

  computed: {
    isDisabled() {
      const product = this.selectedItems.find(
        item => item.id == this.product.id
      )
      if (product.option !== undefined) {
        const isDisabled = Object.values(product.option).some(option => !option)
        return isDisabled
      } else {
        const isDisabled = Object.values(
          product.admin_order_product_option_sets
        ).some(option => !option)
        return isDisabled
      }
    }
  },
  mounted() {
    this.checkHEIC(this.product.image, this.product.fileType)

    if (!this.product.option.length) {
      this.showSelectDropdown = false
      this.showProductDescription = true
    } else if (this.checkKey('default')) {
      if (this.product.option.length === 1) {
        if (this.product.option[0].default.length === 1) {
          this.selectedItem = this.product.option[0].default[0]
          this.showSelectDropdown = false
          this.showProductDescription = true
        } else {
          this.showSelectDropdown = true
        }
      } else {
        this.showSelectDropdown = true
        this.showProductDescription = false
      }
    } else {
      this.showSelectDropdown = true
    }
    if (!this.product.option.length) {
      this.showProductDescription = true
    }
  },
  methods: {
    handleClose() {
      //   const validations = this.$refs.selectedItem

      //   const isValid = validations.every(
      //     validation => validation.isSelectedValid !== ''
      //   )
      //   validations.forEach(item => {
      //     if (item.isSelectedValid === '') {
      //       item.$data.showValidationError = true
      //     }
      //   })

      //   if (!isValid) {
      //     this.$emit('unSelectItem', this.product)
      //   }
      this.$emit('hideModal')
    },
    handleSelection() {
      // Handle products without options
      if (!this.product.option.length) {
        this.$emit(
          this.isSelected ? 'unSelectItem' : 'selectItem',
          this.product,
          true
        )
        return
      }

      // Handle single option product with one default value
      const hasSingleDefaultOption =
        this.product.option.length === 1 &&
        this.checkKey('default') &&
        this.product.option[0].default.length === 1

      if (hasSingleDefaultOption) {
        this.$emit(
          this.isSelected ? 'unSelectItem' : 'selectItem',
          this.product,
          true
        )
        return
      }

      // Handle products with multiple options
      const validations = this.$refs.selectedItem
      const isValid = validations.every(
        validation => validation.isSelectedValid !== ''
      )

      validations.forEach(item => {
        if (item.isSelectedValid === '' || !item.isSelectedValid) {
          item.$data.showValidationError = true
        }
      })

      if (isValid) {
        this.$emit('hideModal')
      }
    },

    setValue(id, option) {
      const product = this.selectedItems.find(item => item.id == id)
      if (product) {
        if (product.option !== undefined) {
          const value = product.option[option]
          return value || ''
        } else {
          const value = product.admin_order_product_option_sets[option]
          return value || ''
        }
      }
    },
    updateSelection(value, option) {
      this.$emit('selectItem', this.product)
      this.$emit('updateSelection', {
        id: this.product.id,
        option,
        value: this.selectedItem
      })
    },
    checkKey(key) {
      const targetKey = key
      let hasKey = false

      this.product.option.forEach(obj => {
        if (obj.hasOwnProperty(targetKey)) {
          hasKey = true
          return
        }
      })
      return hasKey
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.modal-holder {
  align-items: flex-start;
  min-height: 700px;
  max-height: 700px;
  overflow: hidden;
  position: relative;

  @media (max-width: 575.98px) {
    overflow: auto;
  }

  &.modal-holder-mini {
    min-height: 550px;
    max-height: 550px;
  }

  .close-button {
    position: absolute;
    top: 15px;
    right: 25px;
    z-index: 1000;
    font-size: 1.5rem;
    font-family: 'Editorial';
  }

  .product-region {
    position: fixed;
    top: 0;
    left: 0;
    width: 45%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding: 0 2.5rem;
    padding-top: 4rem;

    @media (max-width: 576px) {
      padding-top: 2rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    .product-name {
      font-weight: 500;
      width: 100%;
      text-align: left;

      @media (min-width: 575.98px) {
        display: none;
      }
    }
    .price {
      color: #25282a;
      font-size: 1.563rem;
      font-weight: bold;
      margin-bottom: 1rem;
      margin-top: 0.5rem;
      padding-bottom: 1rem;
      padding-left: 2rem !important;

      @media (min-width: 575.98px) {
        display: none;
      }
    }

    @media (max-width: 575.98px) {
      position: relative;
      width: 100%;
    }

    .image-region {
      width: 90%;
      margin: 0 auto;
      height: 302px;
      display: flex;

      @media (min-width: 576px) {
        width: 100%;
      }

      .image {
        border: 1px solid #232220;
        padding: 0.75rem;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .image-holder {
          height: 212px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
    .product-text-region {
      p {
        font-size: 0.938rem;
        font-weight: 700;
        color: #232220;
        text-align: left;
        line-height: normal;
        margin-bottom: 0.5rem;
      }
    }
  }

  .product-details {
    width: 55%;
    margin-left: auto;
    text-align: left;
    min-height: 700px;
    max-height: 700px;
    overflow-y: auto;
    padding-top: 3.8rem;
    border-left: 1px solid #000000;

    @media (max-width: 575.98px) {
      position: relative;
      width: 100%;
      border-left: none;
      padding-top: 0rem;
      padding-bottom: 2rem;
      min-height: max-content;
      max-height: max-content;
    }

    &.product-details-mini {
      min-height: 550px;
      max-height: 550px;

      @media (max-width: 575.98px) {
        min-height: max-content;
        max-height: max-content;
      }
    }
    .product-name {
      font-weight: 500;
      width: 90%;
      padding-left: 2rem !important;

      @media (max-width: 575.98px) {
        display: none;
      }
    }
    .price {
      color: #25282a;
      font-size: 1.25rem;
      font-weight: bold;
      margin-bottom: 1rem;
      margin-top: 0.5rem;
      padding-bottom: 1rem;
      padding-left: 2rem !important;

      @media (max-width: 575.98px) {
        display: none;
      }
    }
    .product-description {
      border-top: 1px solid #dfdad2;
      border-bottom: 1px solid #dfdad2;
      padding: 0.8rem 2rem !important;
      margin-bottom: 1rem;

      @media (max-width: 575.98px) {
        margin-top: 1rem;
        border-top: 1px solid #000000;
        border-bottom: 1px solid #dfdad2;
        padding: 0.8rem 1.5rem !important;
      }

      .product-description-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 0.938rem;
          color: #232220;
          font-weight: bold;
        }
      }

      .product-description-content {
        p {
          font-size: 0.938rem;
          color: #232220;
          font-weight: 400;
          line-height: 1.2rem;
          transition: all 0.3s ease-in-out;
          height: 0px;
          overflow: hidden;

          &.active {
            height: max-content;
            padding-top: 1rem;
            padding-bottom: 0.5rem;

            @media (max-width: 575.98px) {
              padding-top: 0rem;
              padding-bottom: 0rem;
            }
          }
        }
      }
    }
    .dropdown-holder {
      padding-left: 2rem !important;
      width: 80%;
      margin-bottom: 1rem;

      @media (max-width: 575.98px) {
        padding: 0.8rem 2.5rem !important;
        width: 100%;
        margin-bottom: 0rem;
      }
      .dropdown-holder-title {
        margin-bottom: 0.25rem;
      }

      p {
        font-size: 0.938rem;
        color: #232220;
        font-weight: bold;
      }
    }
  }

  .button-region {
    display: flex;
    justify-content: start;
    margin: 2rem 0;
    padding-left: 2rem !important;

    @media (max-width: 575.98px) {
      margin-top: 3.5rem !important;
      padding: 0 1.5rem !important;
      justify-content: center;
    }

    .finalize-button {
      background: #24292c;
      color: $main-white;
      font-size: 1rem;
      font-weight: normal;
      font-size: 0.813rem;
      height: 2.5rem;
      text-transform: uppercase;
      border-radius: 40px;
      padding: 0 2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

.product-checkbox {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;

  p {
    font-size: 0.813rem;
    color: #232220;
    font-weight: bold;
    margin-left: 1.8rem;
    position: relative;
    top: -3px;
  }
}

.validation-error {
  color: #ce3c3c !important;
  font-weight: 700 !important;
}

@media (max-width: 575.98px) {
  .image-region {
    margin-bottom: 0rem;
  }
  .product-region {
    flex-wrap: wrap;
  }

  .price {
    margin-top: 1rem;
  }

  .button-region {
    margin-top: 2rem !important;
    padding-bottom: 0rem;
  }

  .image {
    width: 100% !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .image-region {
    margin-bottom: 2rem;
  }
  .product-region {
    flex-wrap: wrap;
  }
  .price {
    margin-top: 1rem;
  }

  .button-region {
    margin-top: 2rem !important;
    padding-bottom: 5rem;
  }

  .image {
    width: 100% !important;
  }
}
.checkmark {
  border-radius: 0 !important;
}
</style>
